export default __webpack_public_path__ + "static/media/0150.ad175791.jpg";